import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
} from "react";
import { useParams, useHistory } from "react-router";
import {
  Grid,
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
} from "@mui/material";

import CreatableSelect from "react-select/creatable";

import Select from "react-select";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Loader from "../../components/Loader";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useGetRoomType from "../../queries/roomType/getRoomTypeLink";
import useEditRoomType from "../../mutation/roomType/editRoomType";
import useCreateAudit from "../../mutation/audit/createAudit";

import RMSRoomTypes from "../../components/roomTypes/RMSRoomTypes";
import WordpressSuites from "../../components/roomTypes/WordpressSuites";
import useGetRoomTypeLinks from "../../queries/roomType/getRoomTypeLinks";

import useProperty from "../../queries/property/getProperties";

import handleRoomTypeDetails from "../../utils/handleRoomTypeDetails";

import { AuthContext } from "../../utils/userProvider";

const errorTextSx = {
  mx: 1.75,
  mt: 0.375,
  fontSize: "0.75rem",
  fontWeight: 400,
  color: "secondary.main",
};

const imageLabelSx = {
  fontSize: 16,
  fontWeight: "bold",
};
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  property: yup.object().required("A Property must be selected."),
  monthlyRent: yup
    .number()
    .typeError("Monthly Rent must be a number")
    .min(0, "Monthly Rent cannot be negative")
    .nullable(true),
  utilitiesFee: yup
    .number()
    .typeError("Utilities Fee must be a number")
    .min(0, "Utilities Fee cannot be negative")
    .nullable(true),
  otherCharges: yup
    .number()
    .typeError("Other Charges must be a number")
    .min(0, "Other Charges cannot be negative")
    .nullable(true),
  display_name: yup.string().nullable(true),
  apartment_type: yup
    .string()
    .nullable(true)
    .test(
      "apartment_type",
      "Invalid apartment type",
      (v) => !v || v === "studio" || v === "shared"
    ),
});

const EditLink = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const { authState, setAuthState } = useContext(AuthContext);

  const [auditResponse, setAuditData] = useCreateAudit();

  const [rmsTable, setRmsTable] = useState([]);
  const [linkedRoomTypeIdsText, setLinkedRoomTypeIdsText] = useState("");
  const [wordpressSuitesTable, setWordpressSuitesTable] = useState([]);

  const [currentData, setCurrentData] = useState();
  const [snapshotCurrent, setSnapshotCurrent] = useState({});

  const [roomTypeLinkResponse, resetLink] = useGetRoomType(id);
  const [linkResponse, resetRoomTypeLink] = useGetRoomTypeLinks();
  const [propertyResponse, resetProperty] = useProperty();

  const [defaultPropertyValue, setDefaultPropertyValue] = useState();
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState();
  const [defaultTags, setDefaultTags] = useState();
  const [tagOptions, setTagOptions] = useState(null);

  const { control, register, handleSubmit, setValue, errors, getValues } =
    useForm({
      resolver: yupResolver(schema),
    });

  const propertyChange = async (value) => {
    if (value != null) {
      setValue("property", { label: value.label, value: value.value });

      setSelectedProperty(value.value);
      if (propertyResponse.data) {
        let selectedProperty = propertyResponse.data.find(
          (item) => item.id == value.value
        );
        Swal.fire({
          title: "Retrieving Room Type Details",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          showConfirmButton: false,
        });
        Swal.showLoading();
        handleRoomTypeDetails(
          {
            clientId: selectedProperty.clientId,
            clientPassword: selectedProperty.clientPassword,
          },
          authState ? authState.jwt : "",
          (response) => {
            setRmsTable([...response.data]);
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });
            Toast.fire({
              icon: "success",
              title: "Retrieved Room Types",
            });
          },
          (err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.message,
            });
          }
        );
      }
    }
  };

  // useEffect(() => {
  //   if (roomTypeResponse.data) {
  //     setRmsTable([...roomTypeResponse.data]);
  //   }
  // }, [roomTypeResponse]);

  useEffect(() => {
    if (propertyResponse.data) {
      setWordpressSuitesTable(
        propertyResponse.data.map((p) => ({
          id: p.id,
          name: p.name,
          suiteIds: p.suiteIds,
        }))
      );
    }
  }, [propertyResponse.data]);



  let [rmsCloudError, setRmsCloudError] = useState();
  let [linkedRoomTypeIdsError, setLinkedRoomTypeIdsError] = useState();
  let [wordpressSuitesError, setWordpressSuitesError] = useState();

  const goBack = () => {
    window.location.href = "/dashboard/roomtypes";
  };

  /* const requirementChange = (value) => {
    if (value != null) {
      setValue("requirement", { label: value.label, value: value.value });
    }
  }; */

  const onSubmit = (values) => {
    let complete = true;
    const arrayLinked = linkedRoomTypeIdsText
      .split(",")
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => !isNaN(n));
    if (arrayLinked.length === 0) {
      complete = false;
      setLinkedRoomTypeIdsError("Please enter at least one Linked Room Type ID");
    } else {
      setLinkedRoomTypeIdsError(null);
    }
    if (selectedWordpressSuites.length < 1) {
      complete = false;
      setWordpressSuitesError("Please select a Suite(s)");
    }
    if (!selectedRMS) {
      complete = false;
      setRmsCloudError("Please select a Room Type");
    }
    if (complete) {
      let dataObj = {};
      dataObj.wordpress = { ids: arrayLinked };
      let arraySuites = [];
      let propsWithoutSuiteIds = [];
      for (var i = 0; i < selectedWordpressSuites.length; i++) {
        let prop = selectedWordpressSuites[i];
        if (prop.suiteIds?.ids && Array.isArray(prop.suiteIds.ids)) {
          for (var j = 0; j < prop.suiteIds.ids.length; j++) {
            let sid = typeof prop.suiteIds.ids[j] === "number" ? prop.suiteIds.ids[j] : parseInt(prop.suiteIds.ids[j], 10);
            if (!isNaN(sid) && !arraySuites.includes(sid)) {
              arraySuites.push(sid);
            }
          }
        } else {
          propsWithoutSuiteIds.push(prop.name || prop.id);
        }
      }
      if (propsWithoutSuiteIds.length > 0) {
        setWordpressSuitesError(
          `The following properties have no Suite ID(s) configured. Please add suite IDs in the Property tab first: ${propsWithoutSuiteIds.join(", ")}`
        );
        return;
      }
      if (arraySuites.length === 0) {
        setWordpressSuitesError("No valid suite IDs found. Please ensure selected properties have Suite IDs configured in the Property tab.");
        return;
      }
      dataObj.suites = { ids: arraySuites };

      dataObj.rmsId = selectedRMS.id.toString();
      dataObj.name = values.name;
      dataObj.monthlyRent =
        values.monthlyRent !== undefined && values.monthlyRent !== ""
          ? parseFloat(values.monthlyRent)
          : null;
      dataObj.utilitiesFee =
        values.utilitiesFee !== undefined && values.utilitiesFee !== ""
          ? parseFloat(values.utilitiesFee)
          : null;
      dataObj.otherCharges =
        values.otherCharges !== undefined && values.otherCharges !== ""
          ? parseFloat(values.otherCharges)
          : null;

      const trimmedDisplay =
        values.display_name !== undefined && values.display_name !== null
          ? String(values.display_name).trim()
          : "";
      dataObj.display_name = trimmedDisplay !== "" ? trimmedDisplay : null;
      dataObj.apartment_type =
        values.apartment_type && values.apartment_type !== ""
          ? values.apartment_type
          : null;

      let tags = [];
      if (values.tags) {
        for (var i = 0; i < values.tags.length; i++) {
          tags.push({
            name: values.tags[i].value,
          });
        }
      }
      dataObj.tags = tags;

      dataObj.property = selectedProperty;
      Swal.fire({
        title: "Create Updates",
        html: `<h4>Please provide a description before submitting your changes</h4>
        <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
        confirmButtonText: "Confirm",
        focusConfirm: false,
        preConfirm: () => {
          const actionDescription =
            Swal.getPopup().querySelector("#actionDescription").value;
          if (!actionDescription) {
            Swal.showValidationMessage(`Please enter description`);
          }
          return {
            actionDescription: actionDescription,
            newData: dataObj,
            snapshotCurrent: snapshotCurrent,
            currentData: currentData,
            type: "room-type",
            action: "update",
          };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setAuditData(result.value);
        }
      });
    }
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Room Type Link Updation Audit Created",
        });
        history.push("/dashboard/roomtypes");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          if (message == "Already Taken") {
            let itemTaken = "<ul>";
            if (messageData.rms) {
              itemTaken += `<li>${selectedRMS.name} (from RMS Cloud)</li>`;
            }
            /* let wordpressTaken = messageData.wordpress;
            for (var i = 0; i < wordpressTaken.length; i++) {
              itemTaken += `<li>${
                selectedWordpress.find(
                  (element) => element.id.toString() == wordpressTaken[i]
                ).name
              } (From Wordpress)</li>`;
            } */

            itemTaken += "</ul>";

            Swal.fire({
              icon: "error",
              title: "Error",
              html:
                "<p>The following Room Types have already been linked in the system. Please select other Room Types to link.</p>" +
                itemTaken,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: auditResponse.errorMessage.message,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.errorMessage.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const [selectedWordpressSuites, setSelectedWordpressSuites] = useState([]);
  const [selectedRMS, setSelectedRMS] = useState();

  const handleWordpressSuitesSelected = ({
    allSelected,
    selectedCount,
    selectedRows,
  }) => {
    setSelectedWordpressSuites(selectedRows);
  };

  const handleRMSSelected = ({ allSelected, selectedCount, selectedRows }) => {
    setSelectedRMS(selectedRows[0]);
  };

  const tagChange = (value) => {
    console.log(value);
    setValue("tags", value);
  };

  useEffect(() => {
    if (linkResponse.data) {
      let data = linkResponse.data;
      let tagOptions = [];
      for (var i = 0; i < data.length; i++) {
        let tags = data[i].tags;
        for (var a = 0; a < tags.length; a++) {
          if (!tagOptions.includes(tags[a].name)) {
            tagOptions.push(tags[a].name);
          }
        }
      }
      let creatableOptions = [];
      for (var i = 0; i < tagOptions.length; i++) {
        creatableOptions.push({
          label: tagOptions[i],
          value: tagOptions[i],
        });
      }
      setTagOptions(creatableOptions);
    }
  }, [linkResponse]);

  useEffect(() => {
    if (roomTypeLinkResponse.data && propertyResponse.data) {
      //setup options
      let data = propertyResponse.data;
      let propertyOptions = [];
      for (var i = 0; i < data.length; i++) {
        let property = data[i];
        propertyOptions.push({
          label: property.name,
          value: property.id,
        });
      }

      setPropertyOptions(propertyOptions);
      setSnapshotCurrent(roomTypeLinkResponse.data);
      setCurrentData(roomTypeLinkResponse.data.id);

      // Set selectedProperty early so Linked Room Types filter works
      if (roomTypeLinkResponse.data.property) {
        let propId = roomTypeLinkResponse.data.property.id || roomTypeLinkResponse.data.property;
        setSelectedProperty(propId);
      }

      if (roomTypeLinkResponse.data.wordpress?.ids && Array.isArray(roomTypeLinkResponse.data.wordpress.ids)) {
        setLinkedRoomTypeIdsText(roomTypeLinkResponse.data.wordpress.ids.join(", "));
      }
      setValue("monthlyRent", roomTypeLinkResponse.data.monthlyRent ?? "");
      setValue("utilitiesFee", roomTypeLinkResponse.data.utilitiesFee ?? "");
      setValue("otherCharges", roomTypeLinkResponse.data.otherCharges ?? "");
      setValue(
        "apartment_type",
        roomTypeLinkResponse.data.apartment_type || ""
      );

      if (roomTypeLinkResponse.data.suites?.ids && Array.isArray(roomTypeLinkResponse.data.suites.ids) && wordpressSuitesTable.length > 0) {
        let initialWordpressSuites = [];
        let suitesArray = roomTypeLinkResponse.data.suites.ids;
        for (var a = 0; a < suitesArray.length; a++) {
          let suiteId = typeof suitesArray[a] === "number" ? suitesArray[a] : parseInt(suitesArray[a], 10);
          let prop = wordpressSuitesTable.find(
            (p) => p.suiteIds?.ids && Array.isArray(p.suiteIds.ids) && p.suiteIds.ids.includes(suiteId)
          );
          if (prop) initialWordpressSuites.push(prop);
        }
        setSelectedWordpressSuites(initialWordpressSuites);
      }

      //set tags
      let tags = roomTypeLinkResponse.data.tags;
      if (tags) {
        let initialTags = [];
        for (var i = 0; i < tags.length; i++) {
          initialTags.push({
            label: tags[i].name,
            value: tags[i].name,
          });
        }
        setValue("tags", initialTags);
        setDefaultTags(initialTags);
      } else {
        setDefaultTags([]);
      }

      //set property
      let hasDefault = false;
      if (roomTypeLinkResponse.data.property) {
        for (var i = 0; i < propertyOptions.length; i++) {
          let req = propertyOptions[i];
          console.log(req);
          if (
            req.label == roomTypeLinkResponse.data.property.name &&
            req.value == roomTypeLinkResponse.data.property.id
          ) {
            hasDefault = true;
            break;
          }
        }
      }
      if (hasDefault) {
        let propId = roomTypeLinkResponse.data.property.id;
        let defaultValue = {
          label: roomTypeLinkResponse.data.property.name,
          value: propId,
        };
        setDefaultPropertyValue(defaultValue);
        setValue("property", defaultValue);

        //set RMS Cloud Room Type Values
        handleRoomTypeDetails(
          {
            clientId: roomTypeLinkResponse.data.property.clientId,
            clientPassword: roomTypeLinkResponse.data.property.clientPassword,
          },
          authState ? authState.jwt : "",
          (response) => {
            setRmsTable([...response.data]);
            let rmsTable = response.data;
            let initialRMS = [];
            for (var i = 0; i < rmsTable.length; i++) {
              if (rmsTable[i].id == roomTypeLinkResponse.data.rmsId) {
                initialRMS = rmsTable[i];
                break;
              }
            }
            if (initialRMS) {
              setSelectedRMS(initialRMS);
            }
          },
          (err) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: err.message,
            });
          }
        );
      }
    }
  }, [
    roomTypeLinkResponse.data,
    linkResponse.data,
    propertyResponse.data,
    wordpressSuitesTable,
  ]);

  /* useEffect(() => {
    if (tagOptions.length > 0) {
      setDefaultTags(defaultTags);
      setValue("tags", defaultTags);
    }
  }, [tagOptions]); */

  const renderContent = () => {
    return (
      <Box
        component="form"
        noValidate
        onSubmit={authState.editAccess && handleSubmit(onSubmit)}
        sx={{ width: "100%" }}
      >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormPageCard>
                <FormPageHeader
                  title={
                    authState.editAccess
                      ? "Edit Room Type Link"
                      : "Room Type Link"
                  }
                  onBack={goBack}
                />
                <TextField
                  name="name"
                  margin="normal"
                  fullWidth
                  label="Name*"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    roomTypeLinkResponse.data && roomTypeLinkResponse.data.name
                  }
                  error={errors.name != null}
                  helperText={errors.name != null ? errors.name.message : null}
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="display_name"
                  margin="normal"
                  fullWidth
                  label="Display name"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    roomTypeLinkResponse.data &&
                    roomTypeLinkResponse.data.display_name
                      ? roomTypeLinkResponse.data.display_name
                      : ""
                  }
                  error={errors.display_name != null}
                  helperText={
                    errors.display_name != null
                      ? errors.display_name.message
                      : "Shown to guests (e.g. on booking flows)."
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <Controller
                  name="apartment_type"
                  control={control}
                  defaultValue={
                    (roomTypeLinkResponse.data &&
                      roomTypeLinkResponse.data.apartment_type) ||
                    ""
                  }
                  render={({ onChange, value }) => (
                    <TextField
                      name="apartment_type"
                      margin="normal"
                      fullWidth
                      select
                      label="Apartment type"
                      variant="outlined"
                      value={value ?? ""}
                      onChange={(e) => onChange(e.target.value)}
                      error={errors.apartment_type != null}
                      helperText={
                        errors.apartment_type != null
                          ? errors.apartment_type.message
                          : null
                      }
                      disabled={
                        auditResponse.loading || !authState.editAccess
                      }
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value="studio">Studio</MenuItem>
                      <MenuItem value="shared">Shared</MenuItem>
                    </TextField>
                  )}
                />
                <Typography component="h2" variant="h6" sx={{ mt: 2 }}>
                  HK Pricing Configuration
                </Typography>
                <TextField
                  name="monthlyRent"
                  margin="normal"
                  fullWidth
                  label="Monthly Rent"
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  defaultValue={
                    roomTypeLinkResponse.data
                      ? roomTypeLinkResponse.data.monthlyRent
                      : null
                  }
                  error={errors.monthlyRent != null}
                  helperText={
                    errors.monthlyRent != null ? errors.monthlyRent.message : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="utilitiesFee"
                  margin="normal"
                  fullWidth
                  label="Utilities Fee"
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  defaultValue={
                    roomTypeLinkResponse.data
                      ? roomTypeLinkResponse.data.utilitiesFee
                      : null
                  }
                  error={errors.utilitiesFee != null}
                  helperText={
                    errors.utilitiesFee != null ? errors.utilitiesFee.message : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="otherCharges"
                  margin="normal"
                  fullWidth
                  label="Other Charges"
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  defaultValue={
                    roomTypeLinkResponse.data
                      ? roomTypeLinkResponse.data.otherCharges
                      : null
                  }
                  error={errors.otherCharges != null}
                  helperText={
                    errors.otherCharges != null ? errors.otherCharges.message : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <Typography component="p" sx={imageLabelSx}>
                  Tags (For Room Categorization)
                </Typography>
                {(tagOptions != null || !linkResponse.loading) &&
                  defaultTags != null && (
                    <div>
                      <Controller
                        name="tags"
                        defaultValue={defaultTags ? defaultTags : null}
                        control={control}
                        render={({ ...props }) => {
                          return (
                            <CreatableSelect
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: errors.tags
                                    ? "red"
                                    : provided.borderColor,
                                }),
                              }}
                              isMulti
                              defaultValue={defaultTags ? defaultTags : null}
                              options={tagOptions}
                              onChange={tagChange}
                              isDisabled={
                                auditResponse.loading || !authState.editAccess
                              }
                            />
                          );
                        }}
                      />
                      {errors.tags && (
                        <Box sx={errorTextSx}>
                          {errors.tags.message}
                        </Box>
                      )}
                    </div>
                  )}
                {propertyOptions.length > 0 &&
                  roomTypeLinkResponse.data != null && (
                    <div>
                      <Typography component="p" sx={imageLabelSx}>
                        Property
                      </Typography>
                      <div>
                        <Controller
                          name="property"
                          control={control}
                          defaultValue={defaultPropertyValue}
                          render={({ ...props }) => {
                            return (
                              <Select
                                styles={{
                                  control: (provided, state) => ({
                                    ...provided,
                                    borderColor: errors.type
                                      ? "red"
                                      : provided.borderColor,
                                  }),
                                }}
                                defaultValue={defaultPropertyValue}
                                options={propertyOptions}
                                onChange={propertyChange}
                                isDisabled={
                                  auditResponse.loading || !authState.editAccess
                                }
                              />
                            );
                          }}
                        />
                        {errors.property && (
                          <Box sx={errorTextSx}>
                            {errors.property.message}
                          </Box>
                        )}
                      </div>
                    </div>
                  )}
              </FormPageCard>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormPageCard sx={{ height: 560 }}>
                <Typography component="h1" variant="h5">
                  RMS Cloud Room Types
                </Typography>
                <p>
                  {authState.editAccess &&
                    `Please select a
                  Room Type from RMS Cloud`}
                </p>
                <RMSRoomTypes
                  onSelectedRowsChange={handleRMSSelected}
                  data={rmsTable}
                  selectedRow={selectedRMS}
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                {rmsCloudError && (
                  <Box sx={errorTextSx}>{rmsCloudError}</Box>
                )}
              </FormPageCard>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormPageCard>
                <Typography component="h1" variant="h5">
                  Linked Room Type IDs
                </Typography>
                <p>
                  {authState.editAccess
                    ? `Enter the Room Type ID(s) to link, separated by commas (e.g. 1, 2, 3).`
                    : `Linked Room Type ID(s).`}
                </p>
                <TextField
                  fullWidth
                  label="Linked Room Type IDs (comma-separated)"
                  variant="outlined"
                  value={linkedRoomTypeIdsText}
                  onChange={(e) => setLinkedRoomTypeIdsText(e.target.value)}
                  disabled={auditResponse.loading || !authState.editAccess}
                  placeholder="e.g. 1, 2, 3"
                  error={!!linkedRoomTypeIdsError}
                  helperText={linkedRoomTypeIdsError || null}
                />
              </FormPageCard>
            </Grid>
            <Grid item xs={12}>
              <FormPageCard>
                <Typography component="h1" variant="h5">
                  Suites
                </Typography>
                <p>
                  {authState.editAccess
                    ? `Please select the Suite(s) that correspond to this Room Type.`
                    : `Suite(s) for this Room Type.`}
                </p>
                <WordpressSuites
                  onSelectedRowsChange={handleWordpressSuitesSelected}
                  data={wordpressSuitesTable}
                  selectedRows={selectedWordpressSuites}
                  disabled={auditResponse.loading || !authState.editAccess}
                  showSuiteId
                />
                {wordpressSuitesError && (
                  <Box sx={errorTextSx}>
                    {wordpressSuitesError}
                  </Box>
                )}
              </FormPageCard>
            </Grid>
            {authState.editAccess && (
              <Grid item xs={12}>
                <FormPageCard>
                  <FormActions>
                  <Button
                      type="submit"
                      size="large"
                      variant="contained"
                      color="primary"
                      disabled={auditResponse.loading || !authState.editAccess}
                    >
                      Submit
                    </Button>
                </FormActions>
                </FormPageCard>
              </Grid>
            )}
          </Grid>
        </Box>
    );
  };

  return (
    <FormPageShell>
      {(roomTypeLinkResponse.loading ||
        linkResponse.loading ||
        propertyResponse.loading) && (
        <FormPageCard>
          <Loader />
        </FormPageCard>
      )}
      {!roomTypeLinkResponse.loading &&
        !linkResponse.loading &&
        !propertyResponse.loading &&
        renderContent()}
    </FormPageShell>
  );
};

export default EditLink;
